

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-bml-signature.route', ['squid', 'xo-bml-signature.directive']).factory('$BmlSignatureRoute', function ($ComponentRoute) {
        return $ComponentRoute.extend('BmlSignatureRoute', {

            name: 'bmlsignature',
            trackingData: {
                fptiState: 'ppc_signature',
                buzname: {
                    'fullpage': {
                        'pagename': '%::ppc_signature',
                        'pagename2': '%::ppc_signature:member:hermes:',
                        'version': 'member:%:'
                    }
                }
            },
            titleContent: 'consumerCreditInfo.applicationApprovedMessage',
            directive: 'xo-bml-signature-page',

            children: []

        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/bml-display/xo-bml-signature/route.js
// module id = ./components/xo-credit-components/src/bml-display/xo-bml-signature/route.js
// module chunks = 1